uniform float time;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform vec3 uAccentColor;
uniform float uGlow;

varying float pulse;
varying vec2 vUv;
varying vec3 vNormal;

void main() {
  float wave = sin((vUv.x + time * 0.1) * 6.0);
  float flow = clamp(vUv.y + wave * 0.05, 0.0, 1.0);
  float invFlow = 1.0 - flow;

  vec3 base = mix(uColorA, uColorB, flow);
  vec3 complement = vec3(1.0) - uAccentColor;
  vec3 accent = mix(uAccentColor, complement, mix(flow, invFlow, pulse));

  float rim = clamp(1.0 - vNormal.z, 0.0, 1.0);
  float rimWeight = rim * mix(0.3, 0.8, pulse + uGlow * 0.5);
  float glow = smoothstep(0.35, 1.0, rim + uGlow * 0.8);

  vec3 color = mix(base, accent, rimWeight);
  color += accent * glow * 0.35 * uGlow;

  gl_FragColor = vec4(color, 1.0);
}